var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.0131,
    cy: 44.0131,
    r: 44.0131,
    fill: "url(#paint0_linear_213_25)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5365 24.5899C44.9389 23.8034 43.0611 23.8034 41.4635 24.5899L25.5507 32.4245C23.4831 33.4425 23.4831 36.3757 25.5507 37.3937L41.4635 45.2281C43.0611 46.0149 44.9389 46.0149 46.5365 45.2283L62.4493 37.3937C64.5169 36.3757 64.5169 33.4425 62.4493 32.4245L46.5365 24.5899ZM25.642 41.4703C25.8952 41.3456 26.1919 41.3456 26.4451 41.4703L41.4635 48.8645C43.0611 49.651 44.9389 49.651 46.5365 48.8645L61.5549 41.4703C61.808 41.3456 62.1047 41.3456 62.358 41.4703L62.4493 41.5152C64.5169 42.5332 64.5169 45.4665 62.4493 46.4845L46.5365 54.319C44.9389 55.1056 43.0611 55.1056 41.4635 54.319L25.5507 46.4845C23.4831 45.4665 23.4831 42.5332 25.5507 41.5152L25.642 41.4703ZM26.4451 50.5614C26.1919 50.4367 25.8952 50.4367 25.642 50.5614L25.5507 50.6063C23.4831 51.6243 23.4831 54.5576 25.5507 55.5756L41.4635 63.4101C43.0611 64.1966 44.9389 64.1966 46.5365 63.4101L62.4493 55.5756C64.5169 54.5576 64.5169 51.6243 62.4493 50.6063L62.358 50.5614C62.1047 50.4367 61.808 50.4367 61.5549 50.5614L46.5365 57.9556C44.9389 58.7421 43.0611 58.7421 41.4635 57.9556L26.4451 50.5614Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_213_25",
    x1: 44.0131,
    y1: -101.675,
    x2: 44.0131,
    y2: 88.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA4A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1142E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCompliance);
export default __webpack_public_path__ + "static/media/cloud-compliance.2ce67de176ed565e4ff3247c81aeb7c8.svg";
export { ForwardRef as ReactComponent };